import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
const DeliveryPriceList = () => {
    const [deliveryPrice, setDeliveryPrice] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [confirmationLoading, setConfirmationLoading] = useState(false);
    const { permissions } = useContext(AuthContext);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchAllPrices = async () => {
            setLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                if (!token) throw new Error("No access token found.");

                const response = await axios.post(
                    ApiServices.getAllDeliveryLocprice,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );

                const { status, message, data } = response.data;
                if (status === 200) {
                    setDeliveryPrice(data);
                    toast.success(message, { toastId: "delivery-Price-fetch-success" });
                } else {
                    handleError({ response: { status, data: { message } } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setLoading(false);
            }
        };

        fetchAllPrices();
    }, []);

    const handleFilter = (e) => {
        setFilterText(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
    };

    // delete price location
    const handleDeleteLocationPrice = async (id) => {
        const formData = {
            id: id,
        };
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;

            if (!token) {
                throw new Error("No access token found.");
            }
            const response = await axios.delete(ApiServices.deleteDeliveryLocprice, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                data: formData,
                withCredentials: true,
            });

            const updateLocationPrice = deliveryPrice.filter(
                (lp) => lp.id !== id
            );
            setDeliveryPrice(updateLocationPrice);

            const { status, message } = response.data;
            if (status === 200) {
                toast.success(message, { toastId: "location-price-delete-success" });
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    // Handle Delete Confirmation
    const handleDeleteConfirmation = (id) => {
        setConfirmationLoading(true);
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            setConfirmationLoading(false);
            if (result.isConfirmed) {
                handleDeleteLocationPrice(id);
            }
        });
    };



    // Define Expandable Component for Actions
    const ExpandableComponent = ({ data }) => (
        <div className="flex justify-start p-4 relative">
            {permissions.some(permission => permission.name === 'admin.view') && (
                <Link
                    to="/delivery/location/price/details"
                    state={{ deliveryPrice: data }}
                    className="mx-2 group"
                >
                    <Eye className="w-5 h-5 text-darkGreen3" />
                    <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                        View Location Price
                    </div>
                </Link>
            )}
            {permissions.some(permission => permission.name === 'admin.edit') && (
                <Link
                    to="/delivery/location/price/update"
                    state={{ deliveryPrice: data }}
                    className="mx-2 group"
                >
                    <PencilSquare className="w-5 h-5 text-dash4" />
                    <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                        Update Delivery Price
                    </div>
                </Link>
            )}
            {permissions.some(permission => permission.name === 'admin.create') && (
                <>
                    <div className="mx-2 my-0 group relative">
                        <button
                            onClick={() => handleDeleteConfirmation(data.id)}
                            disabled={confirmationLoading}
                        >
                            <Trash className="w-5 h-5 text-dash3" />
                        </button>

                        <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash3 text-xs whitespace-nowrap">
                            Delete
                        </div>
                    </div>
                </>
            )}
        </div>
    );

    const columns = [
        // {
        //     name: "State",
        //     sortable: true,
        //     width: "300px",
        //     cell: (row) => (
        //         <div>
        //             <span className="block font-bold">
        //                 {row.firstname ? row.firstname.toUpperCase() : "NOT AVAILABLE"}{" "}
        //                 {row.lastname ? row.lastname.toUpperCase() : "NOT AVAILABLE"}
        //             </span>
        //             <span
        //                 className={`px-3 py-0.5 rounded-md  text-xs ${row.status.toLowerCase() === "active"
        //                     ? "bg-darkGreen3 text-lGrey2"
        //                     : "bg-dash5 text-lGrey2"
        //                     }`}
        //             >
        //                 {row.status ? row.status.toLowerCase() : "NOT AVAILABLE"}
        //             </span>
        //         </div>
        //     ),
        // },
        {
            name: "State",
            selector: (row) => row.state,
            sortable: true,
            width: "200px",
        },
        {
            name: "City",
            selector: (row) => row.city,
            sortable: true,
            width: "300px",
        },

        {
            name: "Local Gov.",
            selector: (row) => row.lga,
            sortable: true,
            width: "200px",
        },


        {
            name: "Price",
            selector: (row) => row.amount ? CurrencyFormatter(row.amount) : "0.00",
            sortable: true,
            width: "120px",
        },
        // {
        //     name: "Lcda.",
        //     selector: (row) => row.lcda,
        //     sortable: true,
        //     width: "200px",
        // },


    ];


    const filteredItems = deliveryPrice.filter((item) => {
        for (let key in item) {
            if (
                typeof item[key] === "string" &&
                item[key].toLowerCase().includes(filterText.toLowerCase())
            ) {
                return true;
            }
        }
        return false;
    });

    const data = filteredItems.map((deliveryPrice) => ({
        location: deliveryPrice.location ? deliveryPrice.location : "NOT AVAILABLE",
        status: deliveryPrice.status ? deliveryPrice.status : "NOT AVAILABLE",
        city: deliveryPrice.city ? deliveryPrice.city : "NOT AVAILABLE",
        amount: deliveryPrice.amount ? deliveryPrice.amount : "NOT AVAILABLE",
        state: deliveryPrice.state ? deliveryPrice.state : "NOT AVAILABLE",
        lcda: deliveryPrice.lcda ? deliveryPrice.lcda : "NOT AVAILABLE",
        lga: deliveryPrice.lga ? deliveryPrice.lga : "NOT AVAILABLE",
        id: deliveryPrice.id,
        created_at: deliveryPrice.created_at
    }));

    // Sort data based on creation date
    const sortedData = [...data].sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA;
    });

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Location Delivery amount
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">List</p>
                                </li>
                            </ol>
                        </nav>
                    </section>
                    <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
                        <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
                            <input
                                type="search"
                                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Search"
                                value={filterText}
                                onChange={handleFilter}
                            />
                        </div>

                        {permissions.some(permission => permission.name === 'admin.create') && (
                            <Link
                                to="/delivery/location/price/create"
                                className="m-1 w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                            >
                                <span className="flex justify-center sm:justify-start mx-2">
                                    <PlusSquare className="mr-2" />
                                    Add amount
                                </span>
                            </Link>
                        )}
                    </div>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (

                        <DataTable
                            columns={columns}
                            data={sortedData}
                            pagination
                            striped
                            highlightOnHover
                            customStyles={CustomStyles}
                            noDataComponent={<div>No deliveryPrice found</div>}
                            expandableRows
                            expandableRowsComponent={ExpandableComponent}
                        />
                    )}
                </div>
            </MainLayouts>
        </div>
    );
};

export default DeliveryPriceList;


